import { clearAllLocFor } from "@/models/localForage/localForage.model";
import { AgentModel, agentModelSchema } from "@/types";
import { validateArrayWithSchema } from "@/utils/dataValidators.zod";
import localforage from "localforage";

export async function locForSetAgentModels(
  agentModels: AgentModel[]
): Promise<void> {
  await localforage.setItem("agent-models", agentModels);
}

export async function locForGetAgentModels(): Promise<AgentModel[] | null> {
  const localforageData = await localforage.getItem("agent-models");
  if (!localforageData) {
    return null;
  }

  const validatedData = validateArrayWithSchema<AgentModel>(
    localforageData,
    agentModelSchema,
    "Agent Model"
  );

  if (validatedData) {
    return validatedData;
  }

  console.error("locForGetAgentModels: Invalid agent models", localforageData);
  await clearAllLocFor();
  window.location.reload();
  return null;
}
